import { useCallback } from 'react';
import { useTrack } from 'use-analytics';

export enum Action {
  CLICKED = 'clicked',
  DELETED = 'deleted',
  ADDED = 'added',
  SAVED = 'saved',
  RESET = 'reset',
  TOGGLED = 'toggled',
  CANCELLED = 'cancelled',
  UPDATED = 'updated',
  SENT = 'sent',
  AWARDED = 'awarded',
  SEARCHED_QUERY = 'searched_query',
  SEARCH_RESULT_CLICKED = 'search_result_clicked',
}

export enum Target {
  DEMAND = 'demand',
  DEMAND_PROCESS_STEP = 'demand_process_step',
  NEGOTIATION_CASE = 'negotiation_case',
  NEGOTIATION_CASE_REMINDER = 'negotiation_case_reminder',
  DATA_GRID_ROW = 'datagrid_row',
  FILTER = 'filter',
  FILTER_FAVORITES = 'filter_favorites',
  DEMAND_PRIORITY = 'demand_priority',
  WIDGET_EDIT = 'widget_edit',
  WIDGET_SAVE = 'widget_save',
  SEARCH = 'search',
  SEARCH_RESULT_CONTRACT = 'search_result_contract',
  SEARCH_RESULT_PURCHASE_ORDER = 'search_result_purchase_order',
  SEARCH_RESULT_PURCHASE_REQUISITION = 'search_result_purchase_requisition',
  SEARCH_RESULT_SOURCING_PROJECT = 'search_result_sourcing_project',
}

export const useTrackInteraction = () => {
  const track = useTrack();

  const trackInteraction = useCallback(
    (target: Target, action: Action, props?: any) => {
      return track(`${target}_${action}`, props);
    },
    [track],
  );
  return trackInteraction;
};
